<template>
  <v-layout class="fontlao">
    <v-navigation-drawer v-model="drawer">
      <v-list-item
        :prepend-avatar="require('../../../src/assets/logo.png')"
        :title="title"
      ></v-list-item>

      <v-divider></v-divider>

      <v-list density="compact" nav>
        <v-list-group
          v-for="(item, index) in items"
          :key="index"
          :value="item.route"
          :prepend-icon="item.icon"
          :append-icon="item.menus == null ? 'mdi-chevron-right' : ''"
        >
          <template v-slot:activator="{ props }">
            <v-list-item
              v-if="item.menus"
              v-bind="props"
              :title="item.menu_name"
            />
            <v-list-item
              v-else
              v-bind="props"
              :title="item.menu_name"
              :to="item.route"
            />
          </template>

          <v-list-item
            v-for="(menu, i) in item.menus"
            :key="i"
            :title="menu.menu_name"
            :to="menu.route"
          />
        </v-list-group>
      </v-list>
      <v-spacer></v-spacer>
      <v-footer class="bg-blue fixed inset-x-0 bottom-0 footer">
        <div class="px-4 py-2 bg-blue text-center w-100">
          <strong>Copyright ©</strong> — {{ new Date().getFullYear() }}
        </div>
      </v-footer>
    </v-navigation-drawer>

    <v-main>
      <v-app-bar height="48" :elevation="0" border>
        <v-app-bar-nav-icon @click="drawer = !drawer" />
        <v-row>
          <v-col>
            <v-row class="ml-4">
              <h3>{{ route.meta.name }}</h3></v-row
            >
          </v-col>
        </v-row>

        <v-spacer />

        <div class="mr-4">
          <!-- <v-btn variant="outlined" color="red" class="fontlao" @click="logout()">
            ອອກຈາກລະບົບ
          </v-btn> -->
          <Button type="button" icon="pi pi-user" severity="info" rounded aria-label="User" @click="toggle" aria-haspopup="true" aria-controls="overlay_menu" />
          <Menu ref="menu" id="overlay_menu" :model="user_menu_items" :popup="true" />
          <!-- <v-menu transition="slide-x-transition">
            <template v-slot:activator="{ props }">
              <v-btn icon v-bind="props">
                <v-icon icon="mdi-dots-vertical" />
              </v-btn>
            </template>
            <v-list>
              <v-list-item link>
                <v-list-item-title
                  class="fontlao"
                  :v-text="'ອອກຈາກລະບົບ'"
                  @click="logout()"
                  >ອອກຈາກລະບົບ</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu> -->
        </div>
      </v-app-bar>

      <router-view />

      <LoadingOverlay v-if="loading" />
      <SnackbarSuccess v-if="alertSucces" />
      <SnackbarFailed v-if="alertFail" />
    </v-main>
  </v-layout>
</template>

<script>
import { useDisplay } from "vuetify";
import { computed, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import LoadingOverlay from "../alert/loading-overlay.vue";
import SnackbarFailed from "../alert/Snackbar-Failed.vue";
import SnackbarSuccess from "../alert/Snackbar-Success.vue";
import { useRouter, useRoute } from "vue-router";
import Button from 'primevue/button';
import Menu from 'primevue/menu';
export default {
  components: {
    LoadingOverlay,
    SnackbarSuccess,
    SnackbarFailed,
    Button,
    Menu,
  },
  data: () => ({
    drawer: null,
    title: "Digital Business License",
  }),
  setup() {
    const store = useStore();
    const { width } = useDisplay();
    const router = useRouter();
    const route = useRoute();
    const drawer = ref(null);
    const hideMenu = ref(true);
    const hideImg = ref(true);
    const menu = ref();

    const user_menu_items = ref([
        {
            label: 'Options',
            items: [
                {
                    label: 'ປ່ຽນລະຫັດຜ່ານ',
                    icon: 'pi pi-key',
                    command: () => {
                      router.push({ path: "/change-password" });
                    },
                },
                {
                    label: 'ອອກຈາກລະບົບ',
                    icon: 'pi pi-sign-out',
                    command: () => {
                      logout();
                    },
                }
            ]
        }
    ]);

    const toggle = (event) => {
        menu.value.toggle(event);
    };

    watch(width, (width) => {
      responsive(width);
    });

    onMounted(() => {
      responsive(width.value);
    });

    const responsive = (width) => {
      if (width < 940) {
        hideMenu.value = false;
      } else {
        hideMenu.value = true;
      }

      if (width < 1200) {
        hideImg.value = false;
      } else {
        hideImg.value = true;
      }
    };

    const logout = () => {
      store.dispatch("authPageModule/logout");
    };

    return {
      items: computed(() => store.state["authPageModule"].navigation),
      logout,
      drawer,
      route,
      hideMenu,
      hideImg,
      user_menu_items,
      toggle,
      menu,
    };
  },
  computed: {
    alertSucces: {
      get() {
        return this.$store.state.snackbarSuccess;
      },
    },
    alertFail: {
      get() {
        return this.$store.state.snackbarFailed;
      },
    },
    loading: {
      get() {
        return this.$store.state.LoadingOverlay;
      },
    },
  },
};
</script>

<style>
.fontlao {
  font-family: phetsarath ot !important;
}
</style>
